import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { logout } from './authSlice';
import api from './config';

const initialState = {
  total: 0,
  withToken: 0,
  users: [], // GET /company/:companyId/favorite-users/paginated — clients who favorited this company
  recordsTotal: 0,
  loading: false,
  isSuccess: false,
  errors: []
};

// Stats only (total fans / push-token count) - independent of the paginated
// table's search, see company.service.ts getFavoriteUsersByCompany.
export const fetchFavoriteUsersStats = createAsyncThunk(
  'favoriteUsers/fetchFavoriteUsersStats',
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const companyId = localStorage.getItem('company');
      const response = await api.get(`/company/${companyId}/favorite-users`);
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) dispatch(logout());
      return rejectWithValue(error.response?.data || error);
    }
  }
);

export const fetchFavoriteUsers = createAsyncThunk(
  'favoriteUsers/fetchFavoriteUsers',
  async (params, { rejectWithValue, dispatch }) => {
    try {
      const companyId = localStorage.getItem('company');
      const response = await api.get(`/company/${companyId}/favorite-users/paginated`, { params });
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) dispatch(logout());
      return rejectWithValue(error.response?.data || error);
    }
  }
);

const favoriteUsersSlice = createSlice({
  name: 'favoriteUsers',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFavoriteUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFavoriteUsers.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.isSuccess = true;
        state.users = payload?.data || [];
        state.recordsTotal = payload?.recordsTotal || 0;
      })
      .addCase(fetchFavoriteUsers.rejected, (state, { payload }) => {
        state.loading = false;
        state.isSuccess = false;
        if (payload?.statusCode === 400) state.errors = payload?.message;
      })
      .addCase(fetchFavoriteUsersStats.fulfilled, (state, { payload }) => {
        state.total = payload?.total || 0;
        state.withToken = payload?.withToken || 0;
      });
  }
});

export default favoriteUsersSlice.reducer;
